import { useState, useCallback } from 'react';
import { SellersState } from '../types/branch-office.types';
import { BranchOfficeService } from '../services/branch-office.service';

const initialState: SellersState = {
  sellers: [],
  isLoading: false,
  error: null,
};

export const useSellers = () => {
  const [state, setState] = useState<SellersState>(initialState);

  const setLoading = useCallback((isLoading: boolean) => {
    setState(prev => ({ ...prev, isLoading, error: null }));
  }, []);

  const setError = useCallback((error: string) => {
    setState(prev => ({ ...prev, error, isLoading: false }));
  }, []);

  const fetchSellersByChainAndBranch = useCallback(async (chainId: string, branchId: number) => {
    try {
      setLoading(true);
      const sellers = await BranchOfficeService.getSellersByChainAndBranch(chainId, branchId);
      setState(prev => ({
        ...prev,
        sellers,
        isLoading: false,
        error: null,
      }));
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to fetch sellers';
      setError(errorMessage);
    }
  }, [setLoading, setError]);

  const clearSellers = useCallback(() => {
    setState(prev => ({ ...prev, sellers: [] }));
  }, []);

  const clearError = useCallback(() => {
    setState(prev => ({ ...prev, error: null }));
  }, []);

  return {
    ...state,
    fetchSellersByChainAndBranch,
    clearSellers,
    clearError,
  };
};

